import type { Definition } from '../../../../schema/frameworks/entry.js';
import {
  type CouponSettings,
  couponSettingsFormData,
  type SettingsKeys,
} from '../../../../schema/sessionstore/entry.js';
import type { IUpdateCouponSettingsUseCase } from '../../../domain/entry.js';
import type { SettingsDTO } from './types.js';

export type IUpdateCouponSettingsController = ReturnType<typeof updateCouponSettingsController>;

const createDTO = (settings: CouponSettings): SettingsDTO => ({
  gameAnalysis: settings.gameAnalysis,
  outcomeLabel: settings.outcomeLabel,
  tipsinfo: settings.tipsinfo,
  correction: settings.correction,
});

/**
 * Controller for updating user settings.
 *
 * @param updateCouponSettingsUseCase Use case for updating settings
 * @returns Controller executor function
 */
export function updateCouponSettingsController(updateCouponSettingsUseCase: IUpdateCouponSettingsUseCase) {
  /**
   * Updates coupon settings in session storage.
   *
   * @param product Product from definition
   * @param input Form data payload
   * @param settingsKey Settings key, to update settings for either play or my bets/results
   * @returns Persisted coupon settings
   * @throws {Error} if persist were not permitted
   */
  return async function controller(
    product: Definition['moduleEngine'],
    input: FormData | CouponSettings,
    settingsKey: SettingsKeys
  ): Promise<SettingsDTO> {
    const couponSettings: ReturnType<(typeof couponSettingsFormData)['parse']> =
      input instanceof FormData ? couponSettingsFormData.parse(input) : { ...input, tipsinfoFull: undefined };
    const response = await updateCouponSettingsUseCase.execute({
      product,
      payload: couponSettings,
      settingsKey,
    });

    return createDTO(response);
  };
}
